// PF-8767: the scavenger-hunt QR code links here with a `crushPrompt` query param carrying a
// taxability question. It rides along through signup and the Identity magic-link redirect so
// aviator-client's `/aviator-crush/chat` (CrushSearchParam.PROMPT) can pre-fill the composer.
export const CRUSH_PROMPT_QUERY_PARAM = 'crushPrompt';

export const getCrushPrompt = (): string | undefined =>
  new URLSearchParams(window.location.search).get(CRUSH_PROMPT_QUERY_PARAM) || undefined;
